import axios from 'axios';
import store from '../store';
import router from '../router';
import { message as Message } from './ui';

// 在开发环境下，使用相对路径，让Vue CLI的代理功能生效
// axios.defaults.baseURL = 'http://localhost:8080/api'; // 删除这行
axios.defaults.baseURL = '/api';  // 修改为这样

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const token = store.state.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    Message.error('请求发送失败');
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('logout');
          router.push('/login');
          Message.error('登录已过期，请重新登录');
          break;
        case 403:
          Message.error('没有权限执行此操作');
          break;
        case 404:
          Message.error('请求的资源不存在');
          break;
        case 500:
          Message.error('服务器错误，请稍后重试');
          break;
        default:
          Message.error(error.response.data?.message || '操作失败');
      }
    } else if (error.request) {
      Message.error('网络连接失败，请检查网络设置');
    } else {
      Message.error('请求发送失败');
    }
    return Promise.reject(error);
  }
);

export default axios;
